import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchAllocationUnits, fetchAllocationUnit, deleteAllocationUnit, resetDeleteFailedFlag } from 'redux/allocationUnits/AllocationUnitsActions';
import AllocationUnitsOperations from './AllocationUnitsOperations';

const mapStateToProps = ({ allocationUnits }) => ({
  allocationUnits: allocationUnits.allocationUnits,
  totalEntries: allocationUnits.pageState.totalEntries,
  fetchingAllocationUnits: allocationUnits.fetchingAllocationUnits,
  deleteFailed: allocationUnits.deleteFailed,
  errorMessage: allocationUnits.errorMessage
});

const mapDispatchToProps = dispatch => ({
  allocationUnitsActions: bindActionCreators({ fetchAllocationUnits, fetchAllocationUnit, deleteAllocationUnit, resetDeleteFailedFlag }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AllocationUnitsOperations);



// WEBPACK FOOTER //
// ./src/components/manageAllocationUnits/comp/allocationUnitsOperations/AllocationUnitsOperationsConnector.js